import MuiToolbar from './MuiToolbar';
import MuiLink from './MuiLink';
import MuiLinearProgress from './MuiLinearProgress';
import MuiIconButton from './MuiIconButton';
import MuiSvgIcon from './MuiIcon';
import MuiSelect from './MuiSelect';
import MuiPaper from './MuiPaper';
import MuiSwitch from './MuiSwitch';
import MuiDataGrid from './MuiDataGrid';
import MuiStack from './MuiStack';
import MuiButton from './MuiButton';
import MuiOutlinedInput from './MuiOutlinedInput';
import MuiInputLabel from './MuiInputLabel';
import MuiPickersDay from './MuiPickersDay';
import MuiAutocomplete from './MuiAutocomplete';
import MuiMobileStepper from './MuiMobileStepper';
import MuiRadio from './MuiRadio';
import MuiFormControlLabel from './MuiFormControlLabel';
import MuiChip from './MuiChip';
import MuiFilledInput from './MuiFilledInput';
import MuiBadge from './MuiBadge';
import MuiTimeline from './MuiTimeline';
import MuiDrawer from './MuiDrawer';
import MuiListItemButton from './MuiListItemButton';
import MuiGrid from './MuiGrid';
import MuiCheckbox from './MuiCheckbox';

const components = {
  MuiToolbar,
  MuiLink,
  MuiLinearProgress,
  MuiIconButton,
  MuiSvgIcon,
  MuiSelect,
  MuiPaper,
  MuiSwitch,
  MuiDataGrid,
  MuiStack,
  MuiButton,
  MuiOutlinedInput,
  MuiInputLabel,
  MuiPickersDay,
  MuiAutocomplete,
  MuiMobileStepper,
  MuiRadio,
  MuiFormControlLabel,
  MuiChip,
  MuiFilledInput,
  MuiBadge,
  MuiTimeline,
  MuiDrawer,
  MuiListItemButton,
  MuiGrid,
  MuiCheckbox,
};

export default components;
